import { useEffect } from "react";

// Client-side SEO for SPA pages: title, meta description, canonical, and a
// page-scoped JSON-LD block (removed on unmount so pages don't stack schema).
export function usePageSeo({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    // OpenGraph + Twitter social preview tags (property-based + name-based).
    const setProp = (prop, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setProp("og:type", "website");
    setProp("og:site_name", "Equitas Homes");
    if (title) { setProp("og:title", title); setMeta("twitter:title", title); }
    if (description) { setProp("og:description", description); setMeta("twitter:description", description); }
    if (canonical) { setProp("og:url", canonical); }
    setMeta("twitter:card", "summary_large_image");
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
      link.setAttribute("href", canonical);
    }
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-page-jsonld", "true");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, canonical]);
}
